document.addEventListener('DOMContentLoaded', function () {


  const popup = document.getElementById('popup-info-come-parrucca');

  // Apri
  document.addEventListener('click', function (e) {
    if (e.target.closest('#icon-info-come-parrucca')) {
      popup.hidden = false;
    }
  });

  // Chiudi con la X
  document.addEventListener('click', function (e) {
    if (e.target.closest('#popup-info-come-parrucca .popup-close')) {
      popup.hidden = true;
    }
  });

  // Chiudi cliccando fuori (sull'overlay)
  if (popup) {
    popup.addEventListener('click', function (e) {
      if (e.target === popup) popup.hidden = true;
    });
  }
});